var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.shareIcon.className,domProps:{"innerHTML":_vm._s(_vm.shareIcon.icon)},on:{"click":function($event){return _vm.shareSocial(_vm.shareIcon.name, _vm.shareIcon.shareLink)}}},[_vm._v(" "+_vm._s(_vm.shareIcon.name)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }